module.exports = __webpack_public_path__ + "img/smw-library07.61d008b7.jpg";